
import React from 'react';
import './LandingFooter.css';

const LandingFooter = () => {
    return (
        <footer className="landing-footer">
            <div className="footer-content">
                <div className="footer-brand">
                    <h3 className="footer-logo">Unbot.</h3>
                    <p>L'automatisation intelligente pour les créateurs ambitieux.</p>
                </div>
                <div className="footer-links">
                    <div className="link-col">
                        <h4>Produit</h4>
                        <a href="https://calendly.com/estrades-thyms86/30min" target="_blank" rel="noopener noreferrer">Démo</a>
                    </div>
                    <div className="link-col">
                        <h4>Légal</h4>
                        <a href="/cgu">CGU</a>
                        <a href="/cgv">CGV</a>
                    </div>
                    <div className="link-col">
                        <h4>Contact</h4>
                        <a href="mailto:contact@unbot.io">contact@unbot.io</a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Unbot AI. Tous droits réservés.</p>
            </div>
        </footer>
    );
};

export default LandingFooter;
